const CONSOLE = '/console';
export const PATHS = {
  bind: '/',
  login: `${CONSOLE}/login`,
  steamOrders: `${CONSOLE}/steam-orders`,
  redeemWorkbench: `${CONSOLE}/redeem`,
  redeems: `${CONSOLE}/redeems`,
  redeemFailed: `${CONSOLE}/redeem-failed`,
  proxies: `${CONSOLE}/proxies`,
  cdkeys: `${CONSOLE}/cdkeys`,
  fxQuotes: `${CONSOLE}/fx-quotes`,
  users: `${CONSOLE}/users`,
  settings: `${CONSOLE}/settings`,
} as const;
export type AppPath = (typeof PATHS)[keyof typeof PATHS];

/**
 * Steam 消费历史页 —— **静态页**（`public/steam-history/index.html`），不是路由。
 *
 * 为什么是静态页而不是控制台里的一个路由（2026-10-23 裁定）：
 * 那一页原来是「把 Steam 官网返回的 HTML 塞进 sandbox iframe」⇒ 页面是**第三方
 * 内容**（要 sandbox、要放宽同源、它引用的跨源资源在截图里还画不进去）。改成
 * **我们自己的静态页 + 一份本地 shim 取数**（与 `public/steam-redeem/index.html`
 * 同一范式）⇒ 页面同源、样式与图都是本域的，表格还是**可选中、可复制**的真表格。
 *
 * 主体是**账号**（一个 Steam 账号一份消费历史），所以只带 `username` 一个参数
 * —— 与 `redeemWorkbenchPath` 的成对参数不同，这里不成对。
 */
export function steamHistoryPath(username: string): string {
  return `/steam-history/index.html?username=${encodeURIComponent(username)}`;
}
/**
 * 订单账号级兑换工作台。
 *
 * 这是「我的任务」列表唯一的出口 —— 一行 = 一个（订单号 × 账号）订单账号，
 * 点进去才能输钱包码。所以它是**成对**参数，缺一个都不成立。
 */
export function redeemWorkbenchPath(orderNo: string, username: string): string {
  return `${PATHS.redeemWorkbench}?order_no=${encodeURIComponent(
    orderNo,
  )}&username=${encodeURIComponent(username)}`;
}

/**
 * Steam 兑换失败说明页：详情列点击后新页签打开，展示该失败类型的
 * Steam 官网兑换文案全文。
 */
export function redeemFailedPath(code: string): string {
  return `${PATHS.redeemFailed}?code=${encodeURIComponent(code)}`;
}
